module.exports = __webpack_public_path__ + "static/3-year-warranty-0f5fafa5675bc65b796325577234701d.svg";